import { ResourceStore } from "i18next";
import React, { useContext } from "react";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { GoalCategoryDropDownPropsShape } from "../interfaces/componentTypes";

export const GoalCategoryDropDown: React.FunctionComponent<GoalCategoryDropDownPropsShape> = ({
  handleSelect,
}) => {
  const { DBObject, t, router, uuid } = useContext(TMDataContext);

  var dropdownList = DBObject.GoalType.map((type) => {
    return (
      <option key={uuid()} value={type.id} id={type.id}>
        {type.label}
      </option>
    );
  });

  var handleClick = (element) => {
    var goalType = DBObject.GoalType.find(
      (type) => type.id == element.currentTarget.value
    );
    handleSelect(router.goToForm(goalType.name, "create"));
  };

  return (
    <select
      className="goal-category-dropdown"
      name="goal-categories"
      defaultValue={""}
      onChange={(e) => {
        handleClick(e);
      }}
      id="goal-category-dropdown"
    >
      <option disabled value="">
        {t("views.goals.headings.select_goal_type")}
      </option>
      {dropdownList}
    </select>
  );
};
